import { render, staticRenderFns } from "./MobileBurgerNavAddon.vue?vue&type=template&id=05ffb1b8&"
import script from "./MobileBurgerNavAddon.vue?vue&type=script&lang=js&"
export * from "./MobileBurgerNavAddon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports